"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var condo_brain_1 = require("condo-brain");
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var withStyles_1 = __importDefault(require("@mui/styles/withStyles"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableBody_1 = __importDefault(require("@mui/material/TableBody"));
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
var TableContainer_1 = __importDefault(require("@mui/material/TableContainer"));
var TableHead_1 = __importDefault(require("@mui/material/TableHead"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var Edit_1 = __importDefault(require("@mui/icons-material/Edit"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var moment_1 = __importDefault(require("moment"));
var StyledTableCell = (0, withStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    head: {
        backgroundColor: '#f37f30',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}); })(TableCell_1.default);
var StyledTableRow = (0, withStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}); })(TableRow_1.default);
var useStyles = (0, makeStyles_1.default)(function (theme) { return (0, createStyles_1.default)({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    table: {
        minWidth: 700,
    },
}); });
function ElevatorBookingAdmin() {
    var _this = this;
    var classes = useStyles();
    var _a = (0, react_1.useState)([]), bookings = _a[0], setBookings = _a[1];
    var _b = (0, react_1.useState)(false), bookingOpen = _b[0], setBookingOpen = _b[1];
    var _c = (0, react_1.useState)(undefined), selectedBooking = _c[0], setSelectedBooking = _c[1];
    var _d = (0, react_1.useState)(false), isRejecting = _d[0], setIsRejecting = _d[1];
    var _e = (0, react_1.useState)(''), rejection = _e[0], setRejection = _e[1];
    var admin = new condo_brain_1.AdminManager();
    if (!admin) {
        return (react_1.default.createElement("div", null));
    }
    var fetchBookings = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            admin.getElevatorBookings().then(function (response) {
                setBookings(response);
            });
            return [2 /*return*/];
        });
    }); };
    var showBooking = function (booking) {
        setSelectedBooking(booking);
        setBookingOpen(true);
        setIsRejecting(false);
    };
    var approveBooking = function (e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('elevator_booking[status]', 'true');
        if (selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking.id) {
            admin.approveElevatorBooking(selectedBooking.id, formData)
                .then(function (_response) {
                fetchBookings();
                setBookingOpen(false);
                setIsRejecting(false);
                setRejection('');
            });
        }
    };
    var saveRejection = function (e) {
        e.preventDefault();
        var formData = new FormData();
        formData.append('elevator_booking[status]', 'false');
        formData.append('elevator_booking[rejection]', rejection);
        if (selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking.id) {
            admin.rejectElevatorBooking(selectedBooking.id, formData)
                .then(function (_response) {
                fetchBookings();
                setBookingOpen(false);
                setIsRejecting(false);
            });
        }
    };
    var rejectBooking = function (e) {
        e.preventDefault();
        if (isRejecting === true) {
            saveRejection(e);
        }
        else {
            setIsRejecting(true);
        }
    };
    var bookingType = function (booking) { return (react_1.default.createElement(react_1.default.Fragment, null,
        booking.moveType === 1 && booking.moveIn === true && booking.moveOut === true && (react_1.default.createElement("div", null, "Delivery & Disposal")),
        booking.moveType === 1 && booking.moveIn === true && booking.moveOut === false && (react_1.default.createElement("div", null, "Delivery")),
        booking.moveType === 1 && booking.moveIn === false && booking.moveOut === true && (react_1.default.createElement("div", null, "Disposal")),
        booking.moveType === 2 && booking.moveIn === true && booking.moveOut === true && (react_1.default.createElement("div", null, "Move in & out")),
        booking.moveType === 2 && booking.moveIn === true && booking.moveOut === false && (react_1.default.createElement("div", null, "Move in")),
        booking.moveType === 2 && booking.moveIn === false && booking.moveOut === true && (react_1.default.createElement("div", null, "Move out")))); };
    (0, react_1.useEffect)(function () {
        fetchBookings();
    }, [bookings.length]);
    var bookingPopup = (react_1.default.createElement(Dialog_1.default, { open: bookingOpen, "aria-labelledby": "form-dialog-title", fullWidth: true },
        react_1.default.createElement(DialogTitle_1.default, { id: "form-dialog-title" },
            react_1.default.createElement(react_1.default.Fragment, null,
                selectedBooking !== undefined && selectedBooking.status === condo_brain_1.BookingStatus.Pending && (react_1.default.createElement(react_1.default.Fragment, null,
                    "Pending",
                    ' ')),
                selectedBooking !== undefined && selectedBooking.status === condo_brain_1.BookingStatus.Rejected && (react_1.default.createElement(react_1.default.Fragment, null,
                    "Rejected",
                    ' ')),
                selectedBooking !== undefined && selectedBooking.status === condo_brain_1.BookingStatus.Approved && (react_1.default.createElement(react_1.default.Fragment, null,
                    "Approved",
                    ' ')),
                "Booking Details")),
        react_1.default.createElement(DialogContent_1.default, null,
            react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
                react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                    react_1.default.createElement(TableContainer_1.default, { component: Paper_1.default },
                        react_1.default.createElement(Table_1.default, { className: classes.table, "aria-label": "customized table" },
                            react_1.default.createElement(TableBody_1.default, null,
                                react_1.default.createElement(StyledTableRow, { key: "bookedBy" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "Booked by"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" }, selectedBooking === null || selectedBooking === void 0 ? void 0 :
                                        selectedBooking.user.name,
                                        ' ',
                                        "(", selectedBooking === null || selectedBooking === void 0 ? void 0 :
                                        selectedBooking.user.unit,
                                        ")")),
                                react_1.default.createElement(StyledTableRow, { key: "name1" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "Booking for"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" }, selectedBooking === null || selectedBooking === void 0 ? void 0 :
                                        selectedBooking.name1,
                                        ' ',
                                        "(", selectedBooking === null || selectedBooking === void 0 ? void 0 :
                                        selectedBooking.unit,
                                        ")")),
                                (selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking.name2) && (react_1.default.createElement(StyledTableRow, { key: "bookedBy" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "Booking for"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" }, selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking.name2))),
                                react_1.default.createElement(StyledTableRow, { key: "type" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "Reservation type"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" }, selectedBooking !== undefined && bookingType(selectedBooking))),
                                react_1.default.createElement(StyledTableRow, { key: "from" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "Start"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" }, (0, moment_1.default)(selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking.startTime).format('llll'))),
                                react_1.default.createElement(StyledTableRow, { key: "end" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "End"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" }, (0, moment_1.default)(selectedBooking === null || selectedBooking === void 0 ? void 0 : selectedBooking.endTime).format('llll'))),
                                selectedBooking !== undefined && selectedBooking.deposit > 0 && (react_1.default.createElement(StyledTableRow, { key: "deposit" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "Deposit"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" },
                                        "$",
                                        selectedBooking.deposit))),
                                selectedBooking !== undefined && selectedBooking.rejection && (react_1.default.createElement(StyledTableRow, { key: "rejection" },
                                    react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, "Rejection Reason"),
                                    react_1.default.createElement(StyledTableCell, { scope: "row" }, selectedBooking.rejection)))))),
                    isRejecting === true && (react_1.default.createElement(material_1.TextField, { id: "rejection", label: "Reason for Rejection", multiline: true, style: { width: '100%', marginTop: '20px' }, value: rejection, rows: 50, placeholder: "Enter a reason for rejecting this booking.", onChange: function (e) { return setRejection(e.target.value); } }))))),
        react_1.default.createElement(DialogActions_1.default, null,
            selectedBooking !== undefined && isRejecting === false && selectedBooking.status !== 'true' && (react_1.default.createElement(Button_1.default, { onClick: function (e) { return approveBooking(e); }, color: "primary" }, "Approve")),
            selectedBooking !== undefined && selectedBooking.status !== 'false' && (react_1.default.createElement(Button_1.default, { onClick: function (e) { return rejectBooking(e); }, color: "secondary" }, "Reject")),
            react_1.default.createElement(Button_1.default, { onClick: function () { return setBookingOpen(false); }, color: "secondary" }, "Close"))));
    return (react_1.default.createElement("div", { className: "section flex-grow" },
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 5 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                bookingPopup,
                react_1.default.createElement("h4", { className: "center" }, "Elevator Bookings"),
                react_1.default.createElement(TableContainer_1.default, { component: Paper_1.default },
                    react_1.default.createElement(Table_1.default, { className: classes.table, "aria-label": "customized table" },
                        react_1.default.createElement(TableHead_1.default, null,
                            react_1.default.createElement(TableRow_1.default, null,
                                react_1.default.createElement(StyledTableCell, null, "Type"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Resident"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Phone"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Start"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Ends"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }, "Status"),
                                react_1.default.createElement(StyledTableCell, { align: "right" }))),
                        react_1.default.createElement(TableBody_1.default, null, bookings.map(function (row) { return (react_1.default.createElement(StyledTableRow, { key: row.id },
                            react_1.default.createElement(StyledTableCell, { component: "th", scope: "row" }, bookingType(row)),
                            react_1.default.createElement(StyledTableCell, { align: "right" }, row.name1),
                            react_1.default.createElement(StyledTableCell, { align: "right" },
                                react_1.default.createElement(Link_1.default, { href: "tel:".concat(row.phoneDay), rel: "noopener" }, row.phoneDay)),
                            react_1.default.createElement(StyledTableCell, { align: "right" }, (0, moment_1.default)(row.startTime).format('MMM D, YYYY h:mm a')),
                            react_1.default.createElement(StyledTableCell, { align: "right" }, (0, moment_1.default)(row.endTime).format('MMM D, YYYY h:mm a')),
                            react_1.default.createElement(StyledTableCell, { align: "right" },
                                row.status === condo_brain_1.BookingStatus.Approved && (react_1.default.createElement("div", null, "Approved")),
                                row.status === condo_brain_1.BookingStatus.Pending && (react_1.default.createElement("div", null, "Pending")),
                                row.status === condo_brain_1.BookingStatus.Rejected && (react_1.default.createElement("div", null, "Rejected"))),
                            react_1.default.createElement(StyledTableCell, { align: "right" },
                                react_1.default.createElement(IconButton_1.default, { edge: "end", "aria-label": "edit", onClick: function () { showBooking(row); }, size: "large" },
                                    react_1.default.createElement(Edit_1.default, null))))); }))))))));
}
exports.default = ElevatorBookingAdmin;
